<template>
  <div
    class="elstep"
    :class="{ disabled , isCurrent }"
    :style="itemStyle"
    @click="!disabled && $emit('click')"
  >
    <i v-if="completed" :class="iconClass" class="step-icon"></i>
    <span class="step-label">{{ label }}</span>
  </div>
</template>
<script>
export default {
  name: "StepItem",
  props: {
    label: {
      type: String,
      required: true,
    },
    imageUrl: { type: String, default: "" },
    completed: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isCurrent: { type: Boolean, default: false },
  },
  data() {
    return {
      iconClass: "el-icon-check",
    }
  },
  computed: {
    itemStyle() {
      return  this.imageUrl ? {
        backgroundImage: `url('${this.imageUrl}')`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }: {};
    },
  },
  mounted() {
  }
};
</script>

<style scoped>
.elstep {
  position: relative;
  flex: 1;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  font-weight: bold;
  overflow: hidden;
  cursor: pointer;
}
.step-icon {
  margin-right: 5px;
  display: inline-block;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
}
.step-icon img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.elstep::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  transition: background-color 0.2s;
}

.elstep:hover::before {
  background-color: rgba(173, 216, 230, 0.5);
}

.elstep.disabled {
  cursor: not-allowed;
}
.elstep.isCurrent {
  font-weight: bold;
  font-size: 20px;
  color: #37cfcf;
}
.elstep.disabled:hover::before {
  background-color: transparent;
}
.step-label,
.step-icon {
  position: relative;
  z-index: 2;
}

</style>
